import {
  Links,
  LiveReload,
  Meta,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";

import GoogleTagManagerScript from "~/ThirdPartyScripts/GoogleTagManagerScript";
import KlaviyoScript from "~/ThirdPartyScripts/KlaviyoScript";

interface Props {
  children: React.ReactNode;
  languageCode: string;
}

export const ThirdPartyScripts = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  /*
  if (process.env.NODE_ENV === "development") {
    return null;
  }
    */

  return <>{children}</>;
};

export const Head = ({}: {}) => {
  return (
    <>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />

      <Meta />
      <Links />
      <ThirdPartyScripts>
        <GoogleTagManagerScript />
        <KlaviyoScript />
      </ThirdPartyScripts>
    </>
  );
};

const Document = ({ children, languageCode }: Props) => {
  return (
    <html dir="ltr" lang={languageCode}>
      <head>
        <Head />
      </head>
      <body>
        {children}

        <ScrollRestoration />
        <Scripts />
        <LiveReload />
      </body>
    </html>
  );
};

export default Document;
